/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

export function OurPurpose(props) {
    return (
        <div css={ content_wrapper }>
          <h2 css={ content_heading }>Our Purpose</h2>
          <div css={ content_text }>
            <p>Douglas Property Valuations strives to provide valuation reports that are credible and well-motivated so as to exceed the expectations of our clients and those of the industry. Our valuations are professional and accurate – a result of comprehensive research, experienced application and logically-drawn conclusions.</p>
            <p>Our vision is to be recognised as amongst the most professional and reliable valuation firms within our sphere of operation.</p>
          </div>
        </div>
    )
}

const content_wrapper = css`
    width: 100%;
    min-height: 15vw;
    color: #7a7a7a;
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    text-align: center;
    padding-top: 1.2vw;
`

const content_heading = css`
    font-weight: 600;
    line-height: 1;
    font-size: 2.25vw;
    color: #595858;
    font-family: "Playfair Display", serif;
    letter-spacing: 0.06vw;
`

const content_text = css`
    padding-left: 12vw;
    padding-right: 12vw;
    line-height: 1.7vw;
    font-size: 0.8vw;

    p {
    padding-bottom: 0.8vw;
    }
`
